module.exports = __webpack_public_path__ + "static/media/Support.a007cca8.png";